const vehicleDetailUploadChunkSize = 2000;

const fuelType = {
  DIESEL: 1,
  CNG: 2,
  PETROL: 3,
  ELECTRIC: 4,
  LNG: 5,
};

const fuelTypePresenterMap = {
  1: 'Diesel',
  2: 'CNG',
  3: 'Petrol',
  4: 'Electric',
  5: 'LNG',
}

const fuelTypeMap = {
  DIESEL: 'DIESEL',
  CNG: 'CNG',
  PETROL: 'PETROL',
  ELECTRIC: 'ELECTRIC',
  LNG: 'LNG',
};

module.exports = {
  vehicleDetailUploadChunkSize,
  fuelType,
  fuelTypeMap,
  fuelTypePresenterMap,
};
